module.exports = __webpack_public_path__ + "static/team-big-b8980e7cb7d9305abe1c81cc26aac921.jpg";